module.exports = __webpack_public_path__ + "static/media/UAMedicalResearch.f364399e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/UAMedicalResearch.jpg
// module id = 390
// module chunks = 0